import { HttpService } from './../../store/http/http.service';
import { StoreService } from './../../store/store.service';
import { CanvasService } from './../../services/canvas/canvas.service';
import { ResourceData } from './../../elements/resource/resource.types';
import {
  KeyEvent,
  KeyHandlerService,
} from './../../services/keyhandler/keyhandler.service';
import { Component, OnInit, Input } from '@angular/core';
import { RootComponent } from '../root/root.component';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { FileUploaderComponent } from '../file-uploader/file-uploader.component';
import { ImageDescriptor } from '../../elements/resource/types/shape.type';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import {
  componentsList,
  isNewFileLoading,
  selectProjectIsLoading,
  selectRootFilesBySceneIndex,
  selectStoryBoardFile,
} from '../../projects/project.selector';
import { ShapeService } from '../../element-editor/shape/shape.service';
import { deleteComponent } from '../../element-editor/store/editor.actions';
import { IRIToId } from '../../util/iri';
import { ProjectService } from '../../projects/project.service';

export interface SidePanelConfig {
  endpoint: string;
  params?: Record<string, any>;
}

const baseConfig = {
  endpoint: 'editor/project',
};

@Component({
  selector: 'nw-side-panel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.scss'],
})
export class SidePanelComponent extends RootComponent implements OnInit {
  @Input()
  item: any;
  newItemState: 'file' | 'image' | 'folder' | '' = '';
  newItemName = '';
  newFileField = false;
  opened = false;
  hoveredComponent: string;
  files$: Observable<ResourceData[]>;
  storyBoardFile$: Observable<ResourceData>;
  scenes$: Observable<ResourceData[]>;
  activeItem: any;
  shapeView = true;
  isNewFileLoading$: Observable<boolean>;
  isProjectLoading$: Observable<boolean>;
  selectedProject: ResourceData;
  loading = false;
  get projectIRI() {
    return this.cs.projectIRI;
  }
  components$: Observable<Array<ResourceData>>;
  constructor(
    public cs: CanvasService,
    private route: ActivatedRoute,
    db: StoreService,
    http: HttpService,
    khs: KeyHandlerService,
    readonly dialog: MatDialog,
    readonly shapeService: ShapeService,
    readonly projectService: ProjectService,
    readonly store: Store,
  ) {
    super(db, http, khs);
    // -- // -- // -- // -- // -- // -- // -- //
    this.scenes$ = this.cs.store.select(selectRootFilesBySceneIndex);

    this.storyBoardFile$ = this.cs.store.select(selectStoryBoardFile);
    this.isProjectLoading$ = this.cs.store.select(selectProjectIsLoading);

    this.route.queryParamMap.subscribe(async (param: ParamMap) => {
      this.cs.urlQueryParams.state = param.get('state');
    });

    this.isNewFileLoading$ = this.store.select(isNewFileLoading);

    this.cs.keyEventSubscribe('q', () => this.flipShapeView());
    this.cs.generalEventSubscribe('set-shape-view', () => {
      this.shapeView = true;
    });
    this.components$ = this.cs.store.select(componentsList);
  }

  addComponent(IRI: string) {
    this.shapeService.addImportedShape({ IRI });
  }

  deleteComponent(IRI: string) {
    this.store.dispatch(deleteComponent({ IRI }));
  }

  openComponent(IRI: string) {
    this.shapeService.navigateToFile(IRIToId(IRI));
  }

  discardNew() {
    this.newItemState = '';
    this.newItemName = '';
  }

  keyUp(event: KeyboardEvent) {
    event.stopPropagation();
    if (event.key === 'Enter') {
      this.save();
    }
  }

  addFolder(event: Event) {
    event.stopPropagation();
    this.newItemState = 'folder';
  }

  addFile(event: Event) {
    event.stopPropagation();
    this.newItemState = 'file';
  }
  get relationships() {
    return {
      project: {
        IRI: this.projectIRI,
      },
    };
  }

  addImage(event: Event) {
    event.stopPropagation();
    this.dialog
      .open(FileUploaderComponent, {
        data: { relationships: this.relationships },
      })
      .afterClosed()
      .subscribe(data => {
        if (!data) {
          // This case no new image has been uploaded
          return;
        }
        this.cs.setPicture(data.literals as ImageDescriptor);

        // this.loadData(() => {
        //   this.db.set('sidePanel.selected', data.IRI);
        // });
      });
  }

  _addImage(event: Event) {
    event.stopPropagation();
    this.newItemState = 'image';
  }

  get isShapeSelected() {
    return !!this.shapeService.previewShape;
  }

  async ngOnInit() {}

  get selected$() {
    return this.db.get<string>('sidePanel.selected');
  }

  globalClick() {
    this.save();
  }

  keyEvent(event: KeyEvent) {
    if (event.code === 'Enter') {
      this.save();
    }
  }

  async save() {
    this.projectService.addSceneAfter({
      label: this.newItemName,
    });

    this.newItemName = '';
    this.newItemState = '';
  }

  selectedShapeView() {
    if (!this.isShapeSelected) {
      return;
    }
    this.shapeView = true;
  }

  flipShapeView() {
    if (this.shapeView) {
      this.shapeView = false;
    } else {
      this.selectedShapeView();
    }
  }
}
